import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import {AnnouncementsComponent} from './announcements/announcements.component';
import {EmailTemplatesComponent} from './email-templates/email-templates.component';
import {DocumentsComponent} from './documents/documents.component';
import {ActionsComponent} from './actions/actions.component';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {DataTablesModule} from 'angular-datatables';

@NgModule({
    declarations: [AnnouncementsComponent, EmailTemplatesComponent, DocumentsComponent, ActionsComponent],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        NgbModalModule,
        FormsModule,
        RouterModule,
        DataTablesModule
    ]
})
export class UtilityModule {
}
